import { Button, PageHeader } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { monitoringReportTranslations as translations } from 'locale/monitoringReports'
import { Form } from 'antd'
import SettingsCard from './components/SettingsCard'
import { CheckOutlined } from '@ant-design/icons'
// we need full path here in order to make jest.mock work
import { useState } from 'react'
import useFeatures from 'hooks/useFeatures'
import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { Home } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import { SwitchStates, getSwitchStates, settingsConfig } from './utils'
import { showToast } from 'common/utils'
import NavigationModal from 'components/NavigationModal/NavigationModal'

const MonitoringReportSettingsScreen = () => {
  const { t } = useTranslation(NAMESPACE.MONITORING_REPORTS)
  const [form] = Form.useForm()
  const [isDirty, setIsDirty] = useState(false)
  const features = useFeatures()
  const homeId = useSelector(
    (state: { global: { home: Home } }) => state?.global?.home?.id,
  )

  const mutationFunction = (features: SwitchStates) =>
    postJSON({
      method: 'PUT',
      url: `/list/homes/${homeId}`,
      json: { ...features },
    })

  const { mutateAsync } = useMutation<unknown, unknown, SwitchStates, void>(
    (values) => mutationFunction(values),
    {
      onSuccess: () => {
        showToast({ title: t(translations.TOAST) })
      },
    },
  )

  const switchStates = getSwitchStates(features)

  const handleFinish = (values: unknown) => {
    const castValues = values as SwitchStates
    mutateAsync(castValues)
    setIsDirty(false)
  }

  const handleValuesChange = (values: {}) => {
    if (values) {
      setIsDirty(true)
    }
  }

  return (
    <FormWrapper
      form={form}
      onValuesChange={handleValuesChange}
      name="MonitoringPreferencesForm"
      initialValues={switchStates}
      onFinish={handleFinish}
    >
      <NavigationModal
        canNavigate={!isDirty}
        modalContentText={t(translations.MODAL_CONTENT)}
      />
      <PageHeader
        title={t(translations.PREFERENCES_TITLE)}
        subtitle={t(translations.PREFERENCES_SUBTITLE)}
      />

      {settingsConfig.map((setting) => (
        <SettingsCard
          key={setting.key}
          title={t(setting.translationKey)}
          items={setting.items}
        />
      ))}
      <FixedFooter>
        <Button
          icon={<CheckOutlined />}
          variant="primary"
          type="submit"
          disabled={!isDirty}
        >
          {t(translations.SAVE_CHANGES)}
        </Button>
      </FixedFooter>
    </FormWrapper>
  )
}

const FixedFooter = styled.div.attrs({
  className: 'lmc-fixed-footer', // I don't like this, we need to make a SB component after the removal of the keystone legacy file
})`
  border: none;
  display: flex;
  justify-content: flex-end;
  width: calc(100vw - 290px);
  @media (max-width: 768px) {
    width: 100vw;
  }
`

const FormWrapper = styled(Form)`
  margin: 24px 30px 100px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export default MonitoringReportSettingsScreen
